module.exports = __webpack_public_path__ + "static/media/resume.244c6066.pdf";